export default "__VITE_ASSET__c3c00906__"